module.exports = __webpack_public_path__ + "img/water05_selected.d93ecd62.png";